import moment from "moment";
import _ from "lodash";
import { COLUMN_FILTER_DATE_FORMAT, FILTER, FILTER_CONDITION } from "@constant";

export const TABLE_TAB = {
	BACKLOG: "backlog",
};

export const TABLE_TABS = [
	{
		text: "All Cases Listing",
		value: "all",
	},
	{
		text: "Back Log Cases Listing",
		value: TABLE_TAB.BACKLOG,
	},
	{
		text: "Warranty Cases Listing",
		value: "warranty",
	},
	{
		text: "Contract Cases Listing",
		value: "contract",
	},
	{
		text: "Adhoc Cases Listing",
		value: "adhoc",
	},
	{
		text: "Active Cases Opened in The Last 7 Days Listing",
		value: "active_opened_last_7_days",
	},
	{
		text: "Active Cases Opened in This Month Listing",
		value: "active_opened_in_this_month",
	},
	{
		text: "Active Cases To Follow Up in This Month Listing",
		value: "active_follow_in_this_month",
	},
	{
		text: "Case Creation in This Month Listing",
		value: "created_in_this_month",
	},
	// {
	//   text: 'Cases Cancelled in The Last 7 Days Listing',
	//   value: 'cancelled_last_7_days'
	// },
	{
		text: "Cases Cancelled in This Month Listing",
		value: "cancelled_in_this_month",
	},
	{
		text: "Cases Resolved in The Last 7 Days Listing",
		value: "resolved_last_7_days",
	},
	{
		text: "Cases Resolved in This Month Listing",
		value: "resolved_in_this_month",
	},
	{
		text: "My Created Cases",
		value: "my_created_cases",
	},
];

export const CONVERT_TYPE_OPTIONS = [
	{
		text: "Single Service Order",
		value: "single",
	},
	{
		text: "Multiple Service Order",
		value: "multiple",
	},
];

export const SERVICE_FEE_TYPE_OPTIONS = [
	{
		text: "Fee & Hour Line",
		value: "fee_and_hour",
	},
	{
		text: "Hour Line",
		value: "hour",
	},
];

export const RESOLUTION_TYPE_OPTIONS = [
	{
		text: "Problem Solved",
		value: "problem_solved",
	},
];

export const TABLE_FILTER = () => {
	return {
		[TABLE_TAB.BACKLOG]: {
			latest_schedule_date: [
				{
					type: "date",
					value: FILTER.DATE_TODAY_EXPIRED,
					matchMode: "dateBefore",
					operator: "and",
				},
			],
			case_status: [
				{
					value: "open",
					matchMode: "equals",
					operator: "or",
				},
			],
		},
		warranty: {
			service_category_category_code: [
				{
					value: "WPM",
					matchMode: "equals",
					operator: "or",
				},
				{
					value: "WCM",
					matchMode: "equals",
					operator: "or",
				},
			],
		},
		contract: {
			service_category_category_code: [
				{
					value: "CPM",
					matchMode: "equals",
					operator: "or",
				},
				{
					value: "CCM",
					matchMode: "equals",
					operator: "or",
				},
			],
		},
		adhoc: {
			service_category_category_code: [
				{
					value: "WPM",
					matchMode: "notEquals",
					operator: "and",
				},
				{
					value: "WCM",
					matchMode: "notEquals",
					operator: "and",
				},
				{
					value: "CPM",
					matchMode: "notEquals",
					operator: "and",
				},
				{
					value: "CCM",
					matchMode: "notEquals",
					operator: "and",
				},
			],
		},
		active_opened_last_7_days: {
			case_status: [
				{
					value: "open",
					matchMode: "equals",
					operator: "and",
				},
			],
			created_at: FILTER_CONDITION.LAST_7_DAYS,
		},
		active_opened_in_this_month: {
			case_status: [
				{
					value: "open",
					matchMode: "equals",
					operator: "and",
				},
			],
			created_at: FILTER_CONDITION.THIS_MONTH,
		},
		active_follow_in_this_month: {
			case_status: [
				{
					value: "open",
					matchMode: "equals",
					operator: "and",
				},
			],
			followed_up_by: FILTER_CONDITION.THIS_MONTH,
		},
		created_in_this_month: {
			created_at: FILTER_CONDITION.THIS_MONTH,
		},
		cancelled_in_this_month: {
			case_status: [
				{
					value: "cancelled",
					matchMode: "equals",
					operator: "and",
				},
			],
			resolved_date: FILTER_CONDITION.THIS_MONTH,
		},
		resolved_last_7_days: {
			case_status: [
				{
					value: "closed",
					matchMode: "equals",
					operator: "and",
				},
			],
			resolved_date: FILTER_CONDITION.LAST_7_DAYS,
		},
		resolved_in_this_month: {
			case_status: [
				{
					value: "closed",
					matchMode: "equals",
					operator: "and",
				},
			],
			resolved_date: FILTER_CONDITION.THIS_MONTH,
		},
		my_created_cases: {
			created_by: [
				{
					value: _.get(
						JSON.parse(localStorage.getItem("user-json")),
						"full_name"
					),
					matchMode: "equals",
					operator: "and",
				},
			],
		},
	};
};
